document.getElementById('auth-year').textContent=new Date().getFullYear();